export default __webpack_public_path__ + "static/media/logo.c2ca89d0.png";